import type { components } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation } from "@tanstack/react-query";

const WEB_PUSH_SUBSCRIBE_PATH = "/v1/notification/web-push/subscribe" as const;

type WebPushSubscribeBody = components["schemas"]["WebPushSubscribeBody"];

export const useSubscribeWebPushMutation = () => {
  return useMutation<void, Error, WebPushSubscribeBody>({
    mutationFn: async (body: WebPushSubscribeBody) => {
      await alphartisApiAxios.post(WEB_PUSH_SUBSCRIBE_PATH, body, { skipErrorHandling: true });
    },
  });
};
